import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CategoryDTO } from '../category/category.model';
import { CategoryService } from '../../services/category.service';
import { UserService } from '../../services/user.service';
import { Department } from '../user/department.model';
import { FormBuilder, FormGroup, type FormControl } from '@angular/forms';
import { ResponseCommonForList } from '../../dtos/ResponseDTOs';
import { Category } from '../../dtos/Category';
import { MultiSelectSearch } from '../../helper/MultiSelectSearch';
import { IdName } from '../../dtos/IdName';
import { RoleEnum } from '../../enums/role.enum';


@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrl: './category-list.component.css',
  standalone: false
})
export class CategoryListComponent implements OnInit {

  displayedColumns: string[] = [
    'name',
    'type',
    'department',
    'actions',
  ];
  categoryData: Category[] = [];
  totalCategoryCount!: number;
  pageSize: number = 10;
  currentPage: number = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  typeList: {id: number, type: string}[] = [];
  departments: Department[] = [];

  categoryList: Category[] = [];
  userData : any;
  isAdmin: boolean = false;
  isDepartmentAdmin: boolean = false;
  readonly roleEnum: typeof RoleEnum = RoleEnum;

  filterForm: FormGroup;

  departmentSearch: MultiSelectSearch<IdName>;
  categoryTypeSearch: MultiSelectSearch<IdName>;
  categorySearch: MultiSelectSearch<IdName>;

  constructor(
    private snackBar: MatSnackBar,private categoryService: CategoryService,
    private userService: UserService, private formBuilder: FormBuilder
  ) {
    this.filterForm = this.formBuilder.group({
      departmentIds: [[],],
      categoryTypeIds: [[],],
      ids: [[],]
    });

    this.departmentSearch = new MultiSelectSearch<IdName>(this.filterForm.get('departmentIds') as FormControl, []);
    this.categoryTypeSearch = new MultiSelectSearch<IdName>(this.filterForm.get('categoryTypeIds') as FormControl, []);
    this.categorySearch = new MultiSelectSearch<IdName>(this.filterForm.get('ids') as FormControl, []);
  }

  ngOnInit(): void {
    this.getStorageData();
    this.getAllCategory();
    this.getCategoryType();
    this.getDepartments();
    this.getAllCategoryForFilter();
  }

  getStorageData() {
    let user: any = sessionStorage.getItem("userData")
    this.userData = JSON.parse(user)
    this.isAdmin = this.userData.roleId == RoleEnum.ADMIN;
    this.isDepartmentAdmin = this.userData.roleId == RoleEnum.DEPARTMENT_ADMIN;
  }
  
  getCategoryName(departmentId: number): string | undefined {
    if (!this.typeList) {
      return undefined;
    }
    const type = this.typeList.find((t: { id: number; }) => t.id === departmentId);
    return type ? type.type : undefined;
  }

  getCategoryType(){
    this.categoryService.getCategoryType().subscribe(
      (res: any) => {
        if (res && res.responseObject) {
          console.log('Response:::', res);
          if (Array.isArray(res.responseObject)) {
            this.typeList = res.responseObject.map((type: {id: number, type: string}) => ({
             ...type,
            }));
            this.categoryTypeSearch.setOptions(this.typeList.map(ct => ({id: ct.id, name: ct.type})));
          }
          console.log("typeList:::", this.typeList);
        } else {
          this.snackBar.open('Error fetching types: Invalid response format', 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      },
      (error: any) => {
        this.snackBar.open(`Error fetching type: ${error.message}`, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  getAllCategory( ): void {
    const categoryServiceCall = this.isDepartmentAdmin
    ? this.categoryService.getAllCategoriesByDepartment()
    : this.categoryService.getAllCategory();

    categoryServiceCall.subscribe({
      next: (res:ResponseCommonForList<Category>) => {
        this.categoryData = res.responseObject;
        this.categorySearch.setOptions(this.categoryData.map(c => ({id: c.id, name: c.name})));
      },
      error: (error:any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    });
  }

  getAllCategoryForFilter(): void {
    const filterData = this.filterForm.value;
    if(this.isDepartmentAdmin) {
      this.filterForm.get('departmentIds')?.setValue([this.userData.departmentId]);
    }
    this.categoryService.getAllCategoryForFilter(filterData, this.currentPage, this.pageSize).subscribe(
      (res: any) => {
        console.log(res);
        if(res.responseObject) {
          if (Array.isArray(res.responseObject.categoryDTOList)) {
            this.categoryList = res.responseObject.categoryDTOList.map((category: CategoryDTO) => ({
              ...category,
              }));
            this.totalCategoryCount = res.responseObject.totalCounts; // Set the totalUsersCount property
          } else {
            this.snackBar.open('Error fetching Category: Invalid response format', 'Close', {
              duration: 3000,
              verticalPosition: 'bottom',
              horizontalPosition: 'center'
            });
          }
        } else {
            this.categoryList = [];
        }
      },
      (error: any) => {
        this.snackBar.open(`Error fetching Category: ${error.message}`, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }
  
  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize
    this.getAllCategoryForFilter();
  }

  onFilter() {
    this.getAllCategoryForFilter();
  }

  clearFilter() {
    this.filterForm.reset({
      departmentIds: [],
      categoryTypeIds: [],
      activityIds: []
    });
    this.getAllCategoryForFilter();
  }

  editCategory(element: any): void {
    element.editing = true;
  }

  saveCategory(element: any): void {
  
    const categoryData = { ...element };
    this.categoryService.update(categoryData).subscribe((res: any) => {
      element.editing = false;  
      this.snackBar.open(res.message, 'Close', { duration: 3000 });
      // this.getAllCategory();
      this.getAllCategoryForFilter();
    },
    (error: any) => {
      this.snackBar.open(error.message, 'Close', { duration: 3000 });
    });
  }

  cancelEdit(element: any): void {
    element.editing = false;
    // this.getAllCategory();
    this.getAllCategoryForFilter();
  }

  deleteCategory(element: any): void {
    if (confirm(`Are you sure you want to delete category "${element.name}" ?`)) {
      this.categoryService.deleteById(element.id).subscribe(() => {
          this.snackBar.open('Category Deleted successfully!', 'Close', { duration: 3000 });
          // this.getAllCategory();
          this.getAllCategoryForFilter();
        },
        (error: any) => {
          this.snackBar.open(error.message, 'Close', { duration: 3000 });
        }
      );
    }
  }

  getDepartments(): void {
    this.userService.getDepartments().subscribe(
      (responseObject: Department[]) => {
        this.departments = responseObject.map((department: Department) => ({ id: department.id, departmentName: department.departmentName }));
        this.departmentSearch.setOptions(this.departments.map(d => ({id: d.id, name: d.departmentName})));
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  getDepartmentName(departmentId: number): string | undefined {
    if (!this.departments) {
      return undefined;
    }
    const department = this.departments.find(d => d.id === departmentId);
    return department ? department.departmentName : undefined;
  }

  selectedActivityIds: number[] = [];
  onCategorySelectionChange(ids: number[]) {
    this.selectedActivityIds = ids;
    this.filterForm.get('ids')?.setValue(this.selectedActivityIds);
  }

  selectedDepartmentIds: number[] = [];
  onDepartmentSelectionChange(departmentIds: number[]) {
    this.selectedDepartmentIds = departmentIds;
    this.filterForm.get('departmentIds')?.setValue(this.selectedDepartmentIds);
  }

  selectedCategoryTypeIds: number[] = [];
  onCategoryTypeSelectionChange(ids: number[]) {
    this.selectedCategoryTypeIds = ids;
    this.filterForm.get('categoryTypeIds')?.setValue(this.selectedCategoryTypeIds);
  }
}
